'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isarray = require('isarray');

var _isarray2 = _interopRequireDefault(_isarray);

var _isNumber = require('is-number');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isObject = require('is-object');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('is-string');

var _isString2 = _interopRequireDefault(_isString);

var _dateFns = require('date-fns');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  switch (type) {
    case 'string':
      return (0, _isString2.default)(value);

    case 'number':
      return (0, _isNumber2.default)(value) && !(0, _isString2.default)(value);

    case 'boolean':
      return value === true || value === false;

    case 'object':
      return value === null || (0, _isObject2.default)(value);

    case 'array':
      return value === null || (0, _isarray2.default)(value);

    case 'any':
      return true;

    case 'date':
      return (0, _dateFns.isDate)(value) || (0, _isString2.default)(value);

    default:
      return false;
  }
};